<!--
 * @Description: 修改手机号码
 * @FilePath: /netHallOfficialAccounts/src/views/Business/Renamed/WaterRenamed.vue
-->

<template>
  <div>
    <div>
      <business-status
        v-if="statusInfor"
        :statusInfor="statusInfor"
        :busHandlingId="busHandlingId"
      />
      <customers-news
        v-if="businessNews"
        ref="cuNews"
        :needHandUser="false"
        :customersNews="customersNewsData"
        :businessState="businessState"
        :stateBoolean="isWuserNoFlag"
      />
    </div>
    <div class="vant-parser">
      <parser
        v-if="formConf"
        ref="parser"
        :key="key2"
        :form-conf="formConf"
        @submit="sumbitForm1"
      />
    </div>
    <!-- [nh_00]办理中状态显示 -->
    <div class="footer" v-if="this.businessState === 'see' && stateBoolean">
      <div class="btns">
        <van-button plain type="info" @click="showCancelReport" style="margin-right: 10px">
          取消办理
        </van-button>
        <van-button plain type="info" @click="updateInfo">修改信息</van-button>
      </div>
    </div>
  </div>
</template>

<script>
import store from '@/store';
import { mapState } from 'vuex';
import { Dialog, Toast } from 'vant';
import CustomersNews from '../components/CustomersNews';
import { phoneFormData } from '../Renamed/rename';
import Parser from '@/components/vant-parser/Parser';
import {
  addBusHandling,
  selectWaterUserRel,
  selectBusHandlingById,
  updateBusHandling,
  cancelReport,
  selectHandUser,
} from '@/api/business';
import { selectMaxRelease } from '@/api/feedback';
import BusinessStatus from '../components/BusinessStatus';
export default {
  components: {
    CustomersNews,
    Parser,
    BusinessStatus,
  },
  data() {
    return {
      key2: +new Date(),
      formConf: null,
      businessCode: null,
      moduleCode: null,
      custReadingId: null,
      busHandlingId: null,
      /* businessState: add-新增；see-查看；edit-修改 */
      businessState: null,
      /* 页面修改，取消 */
      stateBoolean: false,
      formReleaseId: null,
      /* 表卡信息 */
      accountNo: null,
      address: {
        areaInfor: '',
        fullAddressInfor: '',
      },
      /* 业务办理信息 */
      statusInfor: null,
      customersNewsData: {},
      renamedFormData: phoneFormData,
      isWuserNoFlag: null, // 是不是户主
    };
  },
  computed: {
    ...mapState('user', {
      homeInfo: (state) => state.homeInfo,
      businessNews: (state) => state.businessNews,
    }),
  },
  mounted() {
    this.into();
  },
  methods: {
    /* 页面初始化 */
    into() {
      if (this.businessNews && this.businessNews.moduleCode) {
        this.businessCode = this.businessNews.businessCode;
        this.moduleCode = this.businessNews.moduleCode;
        this.custReadingId = this.businessNews.custReadingId;
        this.businessState = this.businessNews.businessState;
        this.busHandlingId =
          this.businessNews.busHandlingId !== undefined ? this.businessNews.busHandlingId : null;
        this.accountNo = this.businessNews.accountNo;
        this.address.areaInfor = this.businessNews.accountAddress;
        this.selectMaxRelease();
        if (this.businessState === 'add') {
          this.selectHandUser();
        }
      } else {
        Toast('获取业务类型信息失败，请返回重新选择！');
      }
    },
    /* 户号、办理人信息 */
    async selectHandUser() {
      let waterUserNo = this.accountNo;
      const { status, resultData } = await selectHandUser(waterUserNo);
      if (status === 'complete') {
        this.customersNewsData = resultData[0];
      }
    },
    /* 页面提交 */
    sumbitForm1(data) {
      let userInfo = store.getters.userInfo;
      let cuNews = this.$refs.cuNews.customersData();
      let formData = { ...data, ...cuNews, meterCode: this.accountNo };
      if (this.businessState === 'add') {
        // let submitArg = {
        //   businessCode: this.businessCode,
        //   moduleCode: this.moduleCode,
        //   custReadingId: this.custReadingId,
        //   isReading: true,
        //   formReleaseIds: this.formReleaseId,
        //   formContent: JSON.stringify(formData),
        //   verification: {
        //     clientCode: this.accountNo,
        //     moduleCode: this.moduleCode,
        //   },
        // };
        // this.addBusHandling(submitArg);
        let params = {
          bizCode: 'YHXXBG', // 业务类型编码
          bizHandleId: "",
          // 选择水户绑定的信息
          clientAddress: this.customersNewsData.clientAddress || "", // 用水户地址
          clientCode: this.customersNewsData.clientCode || "", // 用水户户号
          clientName: this.customersNewsData.clientName || "", // 用水户户名
          abodeCode: this.customersNewsData.abodeCode || "", 
          customerNo: this.customersNewsData.customerNo || "", 
          // 登录人信息
          // idCard: formData.idNumber, // 办理人身份证号码
          orderSource: "wx", // 表单申请人人手机号
          phone: formData.mobileNew, // 表单申请人人手机号
          transactor:  userInfo.nickName,
          userId: userInfo.userId, // 登陆人id
        };
        this.addBusHandling(params);
      } else {
        let updateArg = {
          busHandlingId: this.busHandlingId,
          formReleaseIds: this.formReleaseId,
          formContent: JSON.stringify(formData),
          verification: {
            clientCode: this.accountNo,
            moduleCode: this.moduleCode,
          },
        };
        this.updateBusHandling(updateArg);
      }
    },
    // 取消
    showCancelReport() {
      Dialog.confirm({
        message: '您确定取消申请吗？',
        confirmButtonText: '取消申请',
        confirmButtonColor: '#3C7EF0',
        cancelButtonText: '点错了',
        cancelButtonColor: '#767E8C',
      })
        .then(() => {
          this.cancelReport();
        })
        .catch(() => {
          console.log('取消申请');
        });
    },
    /* 取消 */
    async cancelReport() {
      let arg = this.busHandlingId;
      const { status, resultData } = await cancelReport(arg);
      if (status === 'complete') {
        Toast('该业务已取消');
        // 回显页面
        this.setBusinessNews('see');
        this.key2 = +new Date();
        this.formConf = { ...this.formConf, readonly: true };
        this.selectBusHandlingById(this.busHandlingId);
      }
    },
    /* 修改信息 */
    async updateInfo(data) {
      this.setBusinessNews('edit');
      this.key2 = +new Date();
      this.formConf = { ...this.formConf, readonly: false };
      this.selectBusHandlingById(this.busHandlingId);
    },
    /* 获取表单样式 */
    async selectMaxRelease() {
      let data = this.renamedFormData;
      console.log(this.renamedFormData)
      this.formReleaseId = "abfdcf857591ab1a0215f423e967bd43";
        if (this.businessState === 'see') {
          data = { ...data, readonly: true };
        }
        this.formConf = data;
      // let res = {"status":"complete","count":"0","resultData":{"formReleaseId":"abfdcf857591ab1a0215f423e967bd43","formConfigId":"18340841756459008a163ea8d581","businessCode":"0021","moduleCode":"002101","content":"{\"size\":\"medium\",\"span\":24,\"column\":2,\"fields\":[{\"type\":\"default\",\"align\":\"top\",\"justify\":\"start\",\"__config__\":{\"span\":24,\"formId\":\"kM1lzLIcv\",\"layout\":\"rowFormItem\",\"tagIcon\":\"row\",\"children\":[{\"style\":{\"width\":\"100%\"},\"__slot__\":{\"append\":\"\",\"suffix\":\"\",\"prepend\":\"\"},\"disabled\":false,\"readonly\":false,\"clearable\":true,\"__config__\":{\"tag\":\"el-input\",\"_tag\":\"a-input\",\"span\":24,\"label\":\"新用户名\",\"formId\":\"k1JzjUXq0\",\"layout\":\"colFormItem\",\"regList\":[{\"message\":\"请输入正确用户名\",\"pattern\":\"\"}],\"tagIcon\":\"input\",\"document\":\"https://element.eleme.cn/#/zh-CN/component/input\",\"required\":true,\"showItem\":true,\"changeTag\":true,\"renderKey\":\"k1JzjUXq01637827577533\",\"showLabel\":true,\"renderItem\":true},\"__vModel__\":\"clientName\",\"placeholder\":\"请输入新用户名\",\"prefix-icon\":\"\",\"suffix-icon\":\"\",\"__readonly__\":{\"span\":1},\"show-word-limit\":false},{\"style\":{\"width\":\"100%\"},\"__slot__\":{\"append\":\"\",\"suffix\":\"\",\"prepend\":\"\"},\"disabled\":false,\"readonly\":false,\"clearable\":true,\"__config__\":{\"tag\":\"el-input\",\"_tag\":\"a-input\",\"span\":24,\"label\":\"新身份证号\",\"formId\":\"kIipodlyq\",\"layout\":\"colFormItem\",\"regList\":[{\"message\":\"请输入正确身份证号\",\"pattern\":\"/^[1-9]\\\\d{5}(?:18|19|20)\\\\d{2}(?:0[1-9]|10|11|12)(?:0[1-9]|[1-2]\\\\d|30|31)\\\\d{3}[\\\\dXx]$/\"}],\"tagIcon\":\"input\",\"document\":\"https://element.eleme.cn/#/zh-CN/component/input\",\"required\":true,\"showItem\":true,\"changeTag\":true,\"renderKey\":\"kIipodlyq1637827574742\",\"showLabel\":true,\"renderItem\":true},\"__vModel__\":\"idCard\",\"placeholder\":\"请输入新身份证号\",\"prefix-icon\":\"\",\"suffix-icon\":\"\",\"__readonly__\":{\"span\":1},\"show-word-limit\":false},{\"style\":{\"width\":\"100%\"},\"__slot__\":{\"append\":\"\",\"suffix\":\"\",\"prepend\":\"\"},\"disabled\":false,\"readonly\":false,\"clearable\":true,\"__config__\":{\"tag\":\"el-input\",\"_tag\":\"a-input\",\"span\":24,\"label\":\"新联系人\",\"formId\":\"ku6A1eMI7\",\"layout\":\"colFormItem\",\"regList\":[{\"message\":\"请输入正确联系人\",\"pattern\":\"/^[\\\\u4e00-\\\\u9fa5]{2,10}$/\"}],\"tagIcon\":\"input\",\"document\":\"https://element.eleme.cn/#/zh-CN/component/input\",\"required\":true,\"showItem\":true,\"changeTag\":true,\"renderKey\":\"ku6A1eMI71637827582050\",\"showLabel\":true,\"renderItem\":true},\"__vModel__\":\"contacter\",\"placeholder\":\"请输入新联系人\",\"prefix-icon\":\"\",\"suffix-icon\":\"\",\"__readonly__\":{\"span\":1},\"show-word-limit\":false},{\"style\":{\"width\":\"100%\"},\"__slot__\":{\"append\":\"\",\"suffix\":\"\",\"prepend\":\"\"},\"disabled\":false,\"readonly\":false,\"clearable\":true,\"__config__\":{\"tag\":\"el-input\",\"_tag\":\"a-input\",\"span\":24,\"label\":\"新手机号\",\"formId\":\"kRjluj1MG\",\"layout\":\"colFormItem\",\"regList\":[{\"message\":\"请输入正确手机号码\",\"pattern\":\"/^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\\\\d{8}$/\"}],\"tagIcon\":\"input\",\"document\":\"https://element.eleme.cn/#/zh-CN/component/input\",\"required\":true,\"showItem\":true,\"changeTag\":true,\"renderKey\":\"kRjluj1MG1637827586524\",\"showLabel\":true,\"renderItem\":true},\"__vModel__\":\"telephone\",\"placeholder\":\"请输入新手机号\",\"prefix-icon\":\"\",\"suffix-icon\":\"\",\"__readonly__\":{\"span\":1},\"show-word-limit\":false},{\"style\":{\"width\":\"100%\"},\"__slot__\":{\"append\":\"\",\"suffix\":\"\",\"prepend\":\"\"},\"disabled\":false,\"readonly\":false,\"clearable\":true,\"__config__\":{\"tag\":\"el-input\",\"_tag\":\"a-input\",\"span\":24,\"label\":\"过户申请原因\",\"formId\":\"kN0RYAw47\",\"layout\":\"colFormItem\",\"regList\":[],\"tagIcon\":\"input\",\"document\":\"https://element.eleme.cn/#/zh-CN/component/input\",\"required\":true,\"showItem\":true,\"changeTag\":true,\"renderKey\":\"kN0RYAw471637990883564\",\"showLabel\":true,\"renderItem\":true},\"__vModel__\":\"remark\",\"placeholder\":\"请输入过户申请原因\",\"prefix-icon\":\"\",\"suffix-icon\":\"\",\"__readonly__\":{\"span\":1},\"show-word-limit\":false},{\"name\":\"file\",\"accept\":\"image/*\",\"__slot__\":{\"list-type\":true},\"disabled\":false,\"multiple\":false,\"list-type\":\"text\",\"__config__\":{\"tag\":\"el-upload\",\"_tag\":\"a-upload\",\"span\":24,\"label\":\"产权证/购房合同/公证书/证明\",\"formId\":\"kgmTgiCZ2\",\"layout\":\"colFormItem\",\"regList\":[],\"tagIcon\":\"upload\",\"document\":\"https://element.eleme.cn/#/zh-CN/component/upload\",\"fileSize\":5,\"required\":true,\"showItem\":true,\"sizeUnit\":\"MB\",\"changeTag\":true,\"renderKey\":\"kgmTgiCZ21657508249951\",\"showLabel\":true,\"buttonText\":\"点击上传\",\"renderItem\":true},\"__vModel__\":\"houseCertificate\",\"buttonText\":\"\",\"auto-upload\":true,\"placeholder\":\"请上传产权证/购房合同/公证书/证明\",\"__readonly__\":{\"span\":2},\"uploadNumber\":5},{\"name\":\"file\",\"accept\":\"image/*\",\"__slot__\":{\"list-type\":true},\"disabled\":false,\"multiple\":false,\"list-type\":\"text\",\"__config__\":{\"tag\":\"el-upload\",\"_tag\":\"a-upload\",\"span\":24,\"label\":\"户主身份证正反面\",\"formId\":\"kcoaHl1hk\",\"layout\":\"colFormItem\",\"regList\":[],\"tagIcon\":\"upload\",\"document\":\"https://element.eleme.cn/#/zh-CN/component/upload\",\"fileSize\":5,\"required\":true,\"showItem\":true,\"sizeUnit\":\"MB\",\"changeTag\":true,\"renderKey\":\"kcoaHl1hk1657267428099\",\"showLabel\":true,\"buttonText\":\"点击上传\",\"renderItem\":true},\"__vModel__\":\"idCards\",\"buttonText\":\"\",\"auto-upload\":true,\"placeholder\":\"请上传户主身份证正反面\",\"__readonly__\":{\"span\":2},\"uploadNumber\":2},{\"name\":\"file\",\"accept\":\"\",\"__slot__\":{\"list-type\":true},\"disabled\":false,\"multiple\":false,\"list-type\":\"text\",\"__config__\":{\"tag\":\"el-upload\",\"_tag\":\"a-upload\",\"span\":24,\"label\":\"新签订的供用水合同\",\"formId\":\"kUvi5c5XO\",\"layout\":\"colFormItem\",\"regList\":[],\"tagIcon\":\"upload\",\"document\":\"https://element.eleme.cn/#/zh-CN/component/upload\",\"fileSize\":5,\"required\":true,\"showItem\":true,\"sizeUnit\":\"MB\",\"changeTag\":true,\"renderKey\":\"kUvi5c5XO1657703079669\",\"showLabel\":true,\"buttonText\":\"点击上传\",\"renderItem\":true},\"__vModel__\":\"waterContract\",\"buttonText\":\"\",\"auto-upload\":true,\"placeholder\":\"请上传新签订的供用水合同\",\"__readonly__\":{\"span\":2},\"uploadNumber\":5}],\"document\":\"https://element.eleme.cn/#/zh-CN/component/layout#row-attributes\",\"renderKey\":\"kM1lzLIcv1637827546906\",\"layoutTree\":true,\"componentName\":\"row_kM1lzLIcv\"}}],\"gutter\":15,\"formRef\":\"elForm\",\"disabled\":false,\"formBtns\":true,\"readonly\":false,\"formModel\":\"formData\",\"formRules\":\"rules\",\"labelWidth\":100,\"labelPosition\":\"right\"}","isReleaseUse":true,"formVersion":7,"tenantId":"001","isDel":false,"createdBy":"001","createdTime":"2022-07-13 17:05:40","updatedBy":"001","updatedTime":"2022-07-13 17:05:40","createdName":"Admin","updatedName":"Admin","businessType":"BusinessManagement","codeList":"[\"0021\",\"002101\"]"},"success":true}
      // this.formReleaseId = resultData.formReleaseId;
      //   let data = JSON.parse(resultData.content);
      //   if (this.businessState === 'see') {
      //     data = { ...data, readonly: true };
      //   }
      //   this.formConf = data;
      // let arg = {
      //   businessCode: this.businessCode,
      //   moduleCode: this.moduleCode,
      // };
      // const { status, resultData } = await selectMaxRelease(arg);
      // if (status === 'complete' && resultData) {
      //   this.formReleaseId = resultData.formReleaseId;
      //   let data = JSON.parse(resultData.content);
      //   if (this.businessState === 'see') {
      //     data = { ...data, readonly: true };
      //   }
      //   this.formConf = data;
      //   if (this.busHandlingId) {
      //     this.selectBusHandlingById(this.busHandlingId);
      //   }
      // }
    },
    /* 数据查询 */
    async selectBusHandlingById(id) {
      const { status, resultData } = await selectBusHandlingById(id);
      if (status === 'complete') {
        this.statusInfor = resultData;
        this.stateBoolean = resultData.stateBoolean;
        let data = JSON.parse(resultData.formContent);
        // 表卡信息
        this.customersNewsData = {
          handUserVO: data.handUserVO,
          waterUserVO: data.waterUserVO,
        };
        if (data.handUserVO && Object.keys(data.handUserVO).length > 0 && data.handUserVO.clientCode) {
          this.accountNo = data.handUserVO && data.handUserVO.clientCode;
        } else {
          this.accountNo = data.waterUserVO && data.waterUserVO.clientCode;
        }
        this.$nextTick(() => {
          this.$refs.parser.fillForm(data);
        });
      } else {
        this.statusInfor = null;
      }
    },
    /* 新增提交 */
    async addBusHandling(data) {
      const { status, resultData } = await addBusHandling(data);
      if (status === 'complete') {
        let processingDays = resultData.processingDays;
        this.busHandlingId = resultData.busHandlingId;
        this.handerDialog('提交', processingDays);
      }
    },
    /* 修改更新 */
    async updateBusHandling(arg) {
      const { status, resultData } = await updateBusHandling(arg);
      if (status === 'complete') {
        let processingDays = resultData.processingDays;
        this.busHandlingId = resultData.busHandlingId;
        this.handerDialog('修改', processingDays);
      }
    },
    /* 成功后弹框 */
    handerDialog(dialogName, processingDays) {
      Dialog.confirm({
        title: `您的业务办理已${dialogName}成功！`,
        message:
          processingDays !== undefined
            ? `预计在${processingDays}个工作日内完成，请耐心等待，可至“我的办理”中查看办理进度。`
            : '可至“我的办理”中查看办理进度。',
        confirmButtonText: '查看记录',
        confirmButtonColor: '#3C7EF0',
        cancelButtonText: '返回首页',
        cancelButtonColor: '#767E8C',
      })
        .then(() => {
          // 查看记录
          this.setBusinessNews('see');
          this.key2 = +new Date();
          this.formConf = { ...this.formConf, readonly: true };
          this.selectBusHandlingById(this.busHandlingId);
        })
        .catch(() => {
          // 返回首页
          this.$router.push({ path: '/' });
        });
    },
    /* 业务全局变量修改 */
    setBusinessNews(State) {
      this.businessState = State;
      let item = {
        ...this.businessNews,
        businessState: State,
        busHandlingId: this.busHandlingId,
      };
      store.dispatch('user/setBusinessNews', item);
    },
  },
};
</script>

<style lang="less" scoped>
.vant-parser {
  margin: 16px 16px 80px 16px;
  overflow: hidden;
}
.footer {
  display: flex;
  justify-content: space-between;
  padding: 15px 0px 15px 0px;
  background: #ffffff;
  width: 100%;
  position: fixed;
  bottom: 0px;

  .btns {
    width: 100%;
    text-align: center;
    margin: 0px 16px 0px 16px;
    /deep/.van-button--normal {
      width: calc(100% / 2 - 10px);
      border-radius: 8px;
    }
  }
}
</style>
